import { Component, OnInit, ViewChild } from '@angular/core';
import { CommissionService } from '../services/commission.service';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-commission',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './commission.component.html',
  styleUrl: './commission.component.scss',
})
export class CommissionComponent implements OnInit {
  // group: any;
  @ViewChild('remarksModal') remarksModal: any;
  allCommissions: any[] = [];
  groupedByOrder: any[] = [];
  expanded: any = {};
  existingRemarks: any[] = [];
  page = 0;
  size = 10;
  totalPages = 0;

  // For editing commission
  selectedCommission: any = null;
  editStatus = '';
  editRemark = '';

  constructor(
    private commissionService: CommissionService,
    private modalService: NgbModal
  ) {}

  ngOnInit(): void {
    this.getAllCommissions();
  }

  getAllCommissions() {
    this.commissionService.getCommissionDetails().subscribe(
      (response) => {
        this.allCommissions = response.content;
        this.totalPages = response.totalPages;
        this.groupRecords();
      },
      (error) => {
        console.error('Error fetching commission details:', error);
      }
    );
  }

  nextPage() {
    if (this.page < this.totalPages - 1) {
      this.page++;
      this.getAllCommissions();
    }
  }

  prevPage() {
    if (this.page > 0) {
      this.page--;
      this.getAllCommissions();
    }
  }

  openEditModal(commission: any) {
    this.selectedCommission = commission;
    this.editStatus = commission.status;
    this.editRemark = '';
  }

  updateCommission() {
    const payload = {
      commissionId: this.selectedCommission.id,
      status: this.editStatus,
      remarks: this.editRemark,
    };

    this.commissionService.updateCommissionDetails(payload).subscribe(
      () => {
        alert('Commission Updated!');
        this.selectedCommission = null;
        this.getAllCommissions();
      },
      (err) => console.error(err)
    );
  }

  closeModal() {
    this.selectedCommission = null;
    this.modalService.dismissAll();
  }

  groupRecords() {
    const map = new Map();

    this.allCommissions.forEach((c: any) => {
      if (!map.has(c.orderId)) map.set(c.orderId, []);
      map.get(c.orderId).push(c);
    });

    this.groupedByOrder = Array.from(map, ([orderId, records]) => ({
      orderId,
      records,
    }));
  }

  toggleView(orderId: string) {
    this.expanded[orderId] = !this.expanded[orderId];
  }

  viewRemarks(commissionId: string) {
    this.openRemarksModal();
    this.commissionService
      .getCommissionRemarks(commissionId)
      .subscribe((res) => {
        this.existingRemarks = res;
      });
  }
  openRemarksModal() {
    this.modalService.open(this.remarksModal, {
      backdrop: false,
      keyboard: true,
      size: 'lg',
    });
  }
  sumCommission(records: any[]): number {
    if (!records || !records.length) return 0;
    return records.reduce(
      (acc, r) => acc + (r.commissionAmount ?? r.amount ?? 0),
      0
    );
  }
}
